import React from "react";
import { CtaButton } from "./CtaButton";
import { CheckList } from "./CheckList";
import { SectionHeading } from "./SectionHeading";
import { differentCons, differentPros } from "../data/content";
export function ComparisonTable() {
  return <section className="bg-white px-4 pb-16" aria-labelledby="compare-title" data-id="element-28" data-mp="2ppec71u13g7l">
      <div className="mx-auto max-w-5xl" data-id="element-29" data-mp="2unfw1oza3jk4">
        <SectionHeading id="compare-title" title="Why Woodworking Ready™ is different" intro="You don't need another collection of random woodworking pictures. You need plans you can actually follow." data-id="element-30" data-mp="3ic8v3ub767iy" />
        <div className="mt-10 grid gap-6 md:grid-cols-[1.2fr_1fr]" data-id="element-31" data-mp="38czsye66hmli">
          <div className="rounded-xl border-2 border-brand bg-white p-8" data-id="element-32" data-mp="3dcvw6b71xa00">
            <h3 className="font-heading text-lg font-bold uppercase" data-id="element-33" data-mp="3df8lj9f52mn3">
              Woodworking <span className="text-brand" data-id="element-34" data-mp="1wxkvl9a24spv">Ready™</span>
            </h3>
            <div className="mt-5" data-id="element-35" data-mp="21z0g908box7q">
              <CheckList items={differentPros} columns={2} data-id="element-36" data-mp="21vw5fk0cr383" />
            </div>
          </div>
          <div className="rounded-xl bg-neutral-100 p-8" data-id="element-37" data-mp="2dxp4h2fqmle6">
            <h3 className="font-heading text-lg font-bold uppercase text-ink-muted" data-id="element-38" data-mp="29wls4pwwf7hp">Random online plans</h3>
            <div className="mt-5 text-ink-muted" data-id="element-39" data-mp="2nwmobs27xqqu">
              <CheckList items={differentCons} variant="cross" data-id="element-40" data-mp="2nt8pgtsrjzo5" />
            </div>
          </div>
        </div>
        <div className="mt-10 text-center font-heading text-2xl font-bold uppercase" data-id="element-41" data-mp="2ww9q4eyv0ykf">
          <p data-id="element-42" data-mp="2wtx2bl6f7tzg">Stop searching.</p>
          <p className="text-brand" data-id="element-43" data-mp="2sv7oxslducft">Start building.</p>
        </div>
        <div className="mt-6" data-id="element-44" data-mp="2ssv9bm33ke5x">
          <CtaButton data-id="element-45" data-mp="36mcjwhdt2gjt" />
        </div>
      </div>
    </section>;
}